import React from 'react';

import JobSection from '../../../Browse/OpeningsListElement/JobSection';

import styles from './JobModal.module.scss';

const JobModal = ({ job }) => (
  <div className={styles.borderContainer}>
    <JobSection job={job} isSelected shouldShowButtons={false} />
  </div>
);

export default JobModal;
